import type { HotelAmenityData } from '@apps/main/new-desktop/core/models';
import type { HotelFilter } from '@apps/main/new-desktop/modules/hotelFilters';

import type {
  AccommodationType,
  FullStars,
} from '@libs/trip-planner-interfaces';

export interface HotelSelectionFilterPillData {
  type: HotelFilter;
  text: string;
}

export interface HotelSelectionDestinationData {
  destinationText: string;
  numberOfNights?: number;
  activeFiltersAmount: number;
}

export interface HotelSelectionCardContext {
  hotelCode: string;
  ingredientIndex: number;
  isSelected: boolean;
  isPreviouslySeen: boolean;
  accommodationType: AccommodationType;
}

export interface HotelSelectionCardData {
  imageUrls: string[];
  hotelSelectionCardContent: HotelSelectionCardContentData;
  context: HotelSelectionCardContext;
}

export interface HotelSelectionCardContentData {
  title: string;
  subtitle: string;
  stars: FullStars;
  content: string[];
  price: string;
  freeCancellation: boolean;
  amenities: HotelAmenityData[][];
}

export interface HotelSelectionListData {
  data: HotelSelectionCardData[];
  id: number;
}

export enum HotelSelectionViewType {
  List = 'list',
  Map = 'map',
}
